export enum ERoleId {
  VIEWER_NO_SUMMARY = 20,
}
